import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import type { ILabelProps } from './ILabelProps';

const Label = forwardRef<HTMLLabelElement, ILabelProps>(
  (props, forwardedRef) => {
    const { className, ...rest } = props;

    return (
      <label
        className={twMerge(
          'text-retail-text-secondary font-semibold disabled:text-retail-text-tertiary text-base md:text-lg',

          className
        )}
        {...rest}
        ref={forwardedRef}
        onMouseDown={(event) => {
          rest.onMouseDown?.(event);

          // prevent text selection when double clicking label

          if (!event.defaultPrevented && event.detail > 1)
            event.preventDefault();
        }}
      />
    );
  }
);

Label.displayName = 'Label';

export default Label;
